// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './hooks/useAuth';
import ErrorBoundary from './components/ErrorBoundary';
import LoginPage from './components/auth/LoginPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Dashboard from './components/dashboard/Dashboard';
import FundingApplication from './components/application/FundingApplication';
import CDBGHub from './CDBGHub';
import FundingFinder from './components/FundingFinder';
import PublicKnowledgeBase from './components/PublicKnowledgeBase';
import CEDSLoginPage from './components/ceds/CEDSLoginPage';
import CEDSAcceptInvitePage from './components/ceds/CEDSAcceptInvitePage';
import CEDSPortalLayout from './components/ceds/CEDSPortalLayout';
import DocumentLibraryPage from './components/ceds/DocumentLibraryPage';
import WorksheetsPage from './components/ceds/WorksheetsPage';
import AdminPage from './components/ceds/AdminPage';
import DiscussionsPage from './components/ceds/DiscussionsPage';

function AppContent() {
  const { loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', backgroundColor: '#F7F6F3',
        fontFamily: "'Georgia', serif", color: '#122326',
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: 40, height: 40, border: '3px solid #E2E0DB',
            borderTopColor: '#BF6847', borderRadius: '50%',
            animation: 'spin 0.8s linear infinite', margin: '0 auto 16px',
          }} />
          <p style={{ fontSize: 16, margin: 0 }}>Loading PADD Hub...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route
        path="/"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <CDBGHub />}
      />
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />}
      />

      {/* Public tools */}
      <Route path="/funding-finder" element={<FundingFinder />} />
      <Route path="/knowledge-base" element={<PublicKnowledgeBase />} />

      {/* Protected routes */}
      <Route
        path="/dashboard"
        element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
      />
      <Route
        path="/apply/:applicationId"
        element={<ProtectedRoute><FundingApplication /></ProtectedRoute>}
      />

      {/* CEDS Strategy Council Portal */}
      <Route path="/ceds" element={<Navigate to="/ceds/login" replace />} />
      <Route path="/ceds/login" element={<CEDSLoginPage />} />
      <Route path="/ceds/accept-invite" element={<CEDSAcceptInvitePage />} />
      <Route path="/ceds/portal" element={<CEDSPortalLayout />}>
        <Route path="discussions" element={<DiscussionsPage />} />
        <Route path="documents"   element={<DocumentLibraryPage />} />
        <Route path="worksheets"  element={<WorksheetsPage />} />
        <Route path="admin"       element={<AdminPage />} />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
